/**
 * 시스템 > 모니터링 설정 > 이벤트 정책 설정 Store
 *
 * @since 2018-04-23
 * @author devp021
 */
import {getCodeJsonRow} from '~/utils/device-common'
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

function getRuleUnit (type) {
  let unit = ''
  switch (type) {
    // 11: IPS 공격 트래픽 바이트
    // 21: FW 허용 트래픽 바이트
    // 23: FW 거부 트래픽 바이트
    case 11:
    case 21:
    case 23:
      unit = window.$nuxt.$root.$i18n.tc('cmn.bytes', 1)
      break
    // 12: IPS 공격 트래픽 패킷
    // 22: FW 허용 트래픽 패킷
    // 24: FW 거부 트래픽 패킷
    case 12:
    case 22:
    case 24:
      unit = window.$nuxt.$root.$i18n.t('cmn.packet')
      break
    // 13: IPS 공격 건수
    case 13:
      unit = window.$nuxt.$root.$i18n.t('cmn.count')
      break
    default:
      unit = ''
      break
  }
  return unit
}
function getEventRuleDeviceType1 (val, type) {
  if (type === 11) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_threatLog')
  else if (type === 12) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_threatLog')
  else if (type === 13) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_threatLog')
  else if (type === 21) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_firewallLog')
  else if (type === 22) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_firewallLog')
  else if (type === 23) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_firewallLog')
  else if (type === 24) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_firewallLog')
  return val
}
function getEventRuleDeviceType2 (val, type) {
  if (type === 11) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_attackTraffic_byte')
  else if (type === 12) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_attackTraffic_packet')
  else if (type === 13) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_attackCount_count')
  else if (type === 21) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_allowTraffic_byte')
  else if (type === 22) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_allowTraffic_packet')
  else if (type === 23) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_rejectTraffic_byte')
  else if (type === 24) return window.$nuxt.$root.$i18n.t('sm.monitoringSettings_eventRuleSettings_rejectTraffic_packet')
  return val
}

export const state = () => ({
  errorMessage: null,
  apiUrl: {
    attackCate: `${apiPrefix}/filter/attack-ctgry`,
    appCate: `${apiPrefix}/filter/app-category`,
    cntry: `${apiPrefix}/filter/cntry`,
    eventUrl: `${apiPrefix}/event-rule`
  },
  isAddRowEventRule0: null,
  isSelectRowEventRule0: null,
  isMultiRowEventRule0: null,
  eventLevelList: [{event_level_type: 1, event_level_color: '#FF0000'}],
  eventLevelTypeGroup: [],
  eventRuleCmpTypeGroup: [],
  eventRuleCmpStatTypeGroup: [],
  eventRuleList: [],
  eventRuleFilterList: [],
  eventRuleFilterThreatList: [],
  eventRuleFilterNationList: [],
  eventRuleFilterAppCategoryData: [],
  eventRuleId: '',
  netSrvPrtcGroup: [],
  riskGroup: [],
  actionGroup: [
    {
      id: 1,
      str: 'allow'
    },
    {
      id: 2,
      str: 'deny'
    },
    {
      id: 3,
      str: 'reject(reset)'
    },
    {
      id: 4,
      str: 'reject(icmp)'
    },
    {
      id: 5,
      str: 'detect'
    },
    {
      id: 6,
      str: 'notice'
    },
    {
      id: 7,
      str: 'block'
    },
    {
      id: 8,
      str: 'quarantine'
    },
    {
      id: 9,
      str: 'archive'
    }
  ]
})

export const mutations = {
  resetStore (state) {
    state.isAddRowEventRule0 = null
    state.isSelectRowEventRule0 = null
    state.isMultiRowEventRule0 = null
    state.eventLevelList = [{event_level_type: 1, event_level_color: '#FF0000'}]
    state.eventLevelTypeGroup = []
    state.eventRuleCmpTypeGroup = []
    state.eventRuleCmpStatTypeGroup = []
    state.eventRuleList = []
    state.eventRuleFilterList = []
    state.eventRuleFilterThreatList = []
    state.eventRuleFilterNationList = []
    state.eventRuleFilterAppCategoryData = []
    state.eventRuleId = ''
    state.netSrvPrtcGroup = []
    state.riskGroup = []
    state.actionGroup = [
      {
        id: 1,
        str: 'allow'
      },
      {
        id: 2,
        str: 'deny'
      },
      {
        id: 3,
        str: 'reject(reset)'
      },
      {
        id: 4,
        str: 'reject(icmp)'
      },
      {
        id: 5,
        str: 'detect'
      },
      {
        id: 6,
        str: 'notice'
      },
      {
        id: 7,
        str: 'block'
      },
      {
        id: 8,
        str: 'quarantine'
      },
      {
        id: 9,
        str: 'archive'
      }
    ]
  },
  setEventRuleCmpTypeGroup (state) {
    state.eventRuleCmpTypeGroup = []
    state.eventRuleCmpTypeGroup = _.map(getCodeJsonRow('event_rule_cmp_type'), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  setEventRuleCmpTypeName (state, key) {
    if (key !== '') {
      const label = state.eventRuleCmpTypeGroup[--key].label
      return label
    }
  },
  setEventRuleCmpStatTypeGroup (state) {
    state.eventRuleCmpStatTypeGroup = []
    state.eventRuleCmpStatTypeGroup = _.map(getCodeJsonRow('event_rule_cmp_stat_type'), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  setEventRuleCmpStatTypeName (state, key) {
    if (key !== '') {
      const label = state.eventRuleCmpStatTypeGroup[--key].label
      return label
    }
  },
  // 에러 지점 **
  setEventLevelTypeGroup (state) {
    state.eventLevelTypeGroup = []
    state.eventLevelTypeGroup = _.map(getCodeJsonRow('event_level_type'), (item) => {
      return { value: item.key, label: item.val }
    })
  },
  getEventLevelTypeName (state, key) {
    if (key !== '') {
      const label = state.eventLevelTypeGroup[--key].label
      return label
    }
  },
  setNetSrvPrtcGroup (state) {
    state.netSrvPrtcGroup = []
    state.netSrvPrtcGroup = _.map(getCodeJsonRow('net_srv_prtc'), (item) => {
      return { value: item.key, str: item.val }
    })
  },
  setNetSrvPrtcName (state, key) {
    if (key !== '') {
      return state.netSrvPrtcGroup[key].label // --key or key
    }
  },
  setRiskGroup (state) {
    state.riskGroup = []
    state.riskGroup = _.map(getCodeJsonRow('risk_type'), (item) => {
      return { value: item.key, str: item.val }
    })
  },
  setRiskName (state, key) {
    if (key !== '') {
      return state.riskGroup[key].label // --key or key
    }
  },
  setEventRuleFilterNationList (state, data) {
    state.eventRuleFilterNationList = data
  },
  setEventRuleFilterThreatList (state, data) {
    state.eventRuleFilterThreatList = data
  },
  setEventRuleFilterAppCategoryList (state, data) {
    state.eventRuleFilterAppCategoryData = data
  },
  // 이벤트 정책 목록 설정
  setEventRuleList (state, res) {
    state.eventRuleList = res
    const temp = []
    let eventRuleDeviceType1 = ''
    let eventRuleDeviceType2 = ''
    let eventRuleOccurCondition = ''
    let eventRuleCmpTypeName = ''
    let eventRuleCmpStatTypeName = ''
    let eventLevelTypeName = ''
    let eventRuleBlistSrcIp = 1
    let eventRuleBlistSrcPort = 0
    let eventRuleBlistDstIp = 1
    let eventRuleBlistDstPort = 0
    let eventRuleBlistPrtc = 0

    for (let i = 0; i < state.eventRuleList.length; i++) {
      eventRuleDeviceType1 = getEventRuleDeviceType1(eventRuleDeviceType1, state.eventRuleList[i].event_rule_type)
      eventRuleDeviceType2 = getEventRuleDeviceType2(eventRuleDeviceType2, state.eventRuleList[i].event_rule_type)

      if (state.eventRuleList[i].event_rule_cmp_type === 1) eventRuleCmpTypeName = mutations.setEventRuleCmpTypeName(state, 1)
      else if (state.eventRuleList[i].event_rule_cmp_type === 2) eventRuleCmpTypeName = mutations.setEventRuleCmpTypeName(state, 2)
      else if (state.eventRuleList[i].event_rule_cmp_type === 3) eventRuleCmpTypeName = mutations.setEventRuleCmpTypeName(state, 3)
      else if (state.eventRuleList[i].event_rule_cmp_type === 4) eventRuleCmpTypeName = mutations.setEventRuleCmpTypeName(state, 4)
      else if (state.eventRuleList[i].event_rule_cmp_type === 5) eventRuleCmpTypeName = mutations.setEventRuleCmpTypeName(state, 5)

      if (state.eventRuleList[i].event_rule_cmp_stat_type === 1) eventRuleCmpStatTypeName = mutations.setEventRuleCmpStatTypeName(state, 1)
      else if (state.eventRuleList[i].event_rule_cmp_stat_type === 2) eventRuleCmpStatTypeName = mutations.setEventRuleCmpStatTypeName(state, 2)

      if (state.eventRuleList[i].event_rule_occur_type === 1) { // 수치
        const eventRuleType = state.eventRuleList[i].event_rule_type
        const unit = getRuleUnit(eventRuleType)
        eventRuleOccurCondition = window.$nuxt.$root.$i18n.t('sm.eventRuleSettings_table_eventRuleOccurType1', {
          min: state.eventRuleList[i].event_rule_occur_term,
          byte: state.eventRuleList[i].event_rule_occur_cnt,
          unit: _.toLower(unit)
        })
      } else if (state.eventRuleList[i].event_rule_occur_type === 2) { // 비율
        eventRuleOccurCondition = window.$nuxt.$root.$i18n.t('sm.eventRuleSettings_table_eventRuleOccurType2', {
          day: eventRuleCmpTypeName,
          timeSet: eventRuleCmpStatTypeName,
          percent: state.eventRuleList[i].event_rule_cmp_ratio,
          min: state.eventRuleList[i].event_rule_occur_term,
          count: state.eventRuleList[i].event_rule_occur_cnt
        })
      }
      eventLevelTypeName = mutations.getEventLevelTypeName(state, state.eventRuleList[i].event_level_type)
      // 블랙리스트 자동등록 사용 여부
      const eventRuleBlistYn = state.eventRuleList[i].event_rule_blist_yn
      const eventRuleBlistType = state.eventRuleList[i].event_rule_blist_type || 0
      const eventRuleBlistOptSet = JSON.parse(state.eventRuleList[i].event_rule_blist_opt_set)
      const eventRuleBlistTerm = eventRuleBlistOptSet['blist_term']
      eventRuleBlistSrcIp = eventRuleBlistOptSet['src_ip']
      eventRuleBlistSrcPort = eventRuleBlistOptSet['src_port']
      eventRuleBlistDstIp = eventRuleBlistOptSet['dst_ip']
      eventRuleBlistDstPort = eventRuleBlistOptSet['dst_port']
      eventRuleBlistPrtc = eventRuleBlistOptSet['prtc']
      let eventRuleBlistTopn = eventRuleBlistOptSet['topn']
      let eventRuleBlistTopnType = 2
      if (eventRuleBlistTopn === 0) {
        eventRuleBlistTopnType = 1
        eventRuleBlistTopn = 100
      }
      temp.push({
        device_id: state.eventRuleList[i].device_id,
        event_rule_use_yn: state.eventRuleList[i].event_rule_use_yn,
        event_rule_uname: state.eventRuleList[i].event_rule_uname,
        device_uname: state.eventRuleList[i].device_uname,
        device_uname2: state.eventRuleList[i].device_uname2,
        event_rule_id: state.eventRuleList[i].event_rule_id,
        event_rule_desc: state.eventRuleList[i].event_rule_desc,
        event_rule_device_type: state.eventRuleList[i].event_rule_device_type,
        event_rule_device_type1: eventRuleDeviceType1,
        event_rule_device_type2: eventRuleDeviceType2,
        event_rule_type: state.eventRuleList[i].event_rule_type,
        filter: state.eventRuleList[i].filter,
        event_rule_occur_type: state.eventRuleList[i].event_rule_occur_type,
        event_rule_cmp_type: state.eventRuleList[i].event_rule_cmp_type,
        event_rule_cmp_stat_type: state.eventRuleList[i].event_rule_cmp_stat_type,
        event_rule_cmp_ratio: state.eventRuleList[i].event_rule_cmp_ratio,
        event_rule_occur_condition: eventRuleOccurCondition,
        event_rule_occur_term: state.eventRuleList[i].event_rule_occur_term,
        event_rule_occur_cnt: state.eventRuleList[i].event_rule_occur_cnt,
        event_level_type: state.eventRuleList[i].event_level_type,
        event_level_type_name: eventLevelTypeName,
        event_level_color: state.eventRuleList[i].event_level_color,
        event_rule_blist_yn: eventRuleBlistYn,
        event_rule_blist_type: eventRuleBlistType,
        event_rule_blist_term: eventRuleBlistTerm,
        event_rule_blist_src_ip: eventRuleBlistSrcIp,
        event_rule_blist_src_port: eventRuleBlistSrcPort,
        event_rule_blist_dst_ip: eventRuleBlistDstIp,
        event_rule_blist_dst_port: eventRuleBlistDstPort,
        event_rule_blist_prtc: eventRuleBlistPrtc,
        event_rule_blist_topn_type: eventRuleBlistTopnType,
        event_rule_blist_topn: eventRuleBlistTopn
      })
    }
    state.eventRuleList = temp
  },
  // 이벤트 레벨 설정
  setEventLevelList (state, res) {
    state.eventLevelList = res

    const temp = []
    state.eventLevelList.forEach((item) => {
      temp.push({
        event_level_color: item.event_level_color,
        event_level_type: item.event_level_type,
        event_level_type_name: mutations.getEventLevelTypeName(state, item.event_level_type),
        event_sound_file_name: item.event_sound_file_name,
        event_sound_id: item.event_sound_id,
        event_sound_name: item.event_sound_name,
        event_sound_pre_def_yn: item.event_sound_pre_def_yn
      })
    })

    state.eventLevelList = temp
  },
  setErrorMessage (state, payload) {
    const msg = {
      error: payload.msg
    }
    state.errorMessage = msg
  }
}

export const actions = {
  // 현재 범위 참조 : dispatch
  // mutation 범위 참조 : commit
  async getNationListAxios ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.cntry)
    if (code === 'ok') {
      commit('setEventRuleFilterNationList', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getThreatListAxios ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.apiUrl.attackCate)
    if (code === 'ok') {
      commit('setEventRuleFilterThreatList', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async getAppCateListAxios ({commit, state}) {
    const {code, result} = await this.$axios.$get(`${state.apiUrl.appCate}/0`)
    if (code === 'ok') {
      commit('setEventRuleFilterAppCategoryList', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 이벤트 정책 목록 조회
  async getEventRuleListAxios ({commit, state}, load = true) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get('/api/sm/event-rule/0', {loading: load, isSuccessAlert: load})
      if (code.toLowerCase() === 'ok') {
        commit('setEventRuleList', result)
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }

      state.isAddRowEventRule0 = true
      state.isMultiRowEventRule0 = false
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 이벤트 정책 삭제
  async delEventRuleCommandAxios ({state, dispatch}, eventRuleId) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$delete(`/api/sm/event-rule/${eventRuleId}`, {
        loading: false,
        successAlert: false
      }) // multi 삭제 API 지원 확인.

      // 멀티 에러 표현용
      if (res.code !== 'ok') {
        res.event_rule_id = eventRuleId
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 이벤트 정책 사용여부 수정 jupil.Go -> devp011
  async onEventRuleChkUse ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrl.eventUrl}/use`, payload, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  // 이벤트 정책 사용여부 수정, 사용여부 확인 필요.
  async onEventRuleChkInputAxios ({state, dispatch}) {
    const eventRuleIdList = []
    state.eventRuleList.forEach((item) => {
      eventRuleIdList.push([item.event_rule_id, item.event_rule_use_yn])
    })

    const res = {code: 'ok'}
    try {
      const {code} = await this.$axios.$put('/api/sm/event-rule/use', {event_rule_use_list: eventRuleIdList}, {applyMsg: false})
      if (code.toLowerCase() === 'ok') {
        dispatch('getEventRuleListAxios')
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 이벤트 정책 항목 추가
  async getEventRuleItemAddAxios ({state}, eventRuleJson) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$post('/api/sm/event-rule', eventRuleJson, {successAlert: false, headers: { 'Content-Type': 'application/json' }})
      if (code.toLowerCase() === 'ok') {
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return {code, result}
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 이벤트 정책 항목 수정
  async getEventRuleItemUpdateAxios ({state}, eventRuleJson) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put('/api/sm/event-rule', eventRuleJson, {successAlert: false, headers: { 'Content-Type': 'application/json' }})
      if (code.toLowerCase() === 'ok') {
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return {code, result}
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 이벤트 레벨 조회
  async getEventLevelListAxios ({commit}) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get('/api/sm/event-level')
      if (code.toLowerCase() === 'ok') {
        commit('setEventLevelList', result)
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async finalCommand ({state}, type) {
    const apiUri = `${state.apiUrl.eventUrl}/${type}`,
      axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }

    const { code } = await this.$axios.$put(apiUri, void 0, axiosConfig)

    return code.toLowerCase() === 'ok'
  }
}

export const getters = {
}

export const strict = false
